import { createSelector } from 'reselect';

export const getHomeCodiguera = createSelector(state => state.Home.Codigueras, u =>u);
export const getHomeMedicamentos = createSelector(state => state.Home.Medicamentos, u =>u);